// ts-gql-integrity:18d066a8cb1e141842eff4d7bf6eda5f
/*
ts-gql-meta-begin
{
  "hash": "e07fe33e2fd452d517314757c15d6bf4"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type DebtorAndFamilyGroupMembers_group_Organisation_Fragment = { readonly __typename: 'Organisation', readonly registeredName: string | null, readonly id: string, readonly sortName: string | null };

type DebtorAndFamilyGroupMembers_group_Person_Fragment = { readonly __typename: 'Person', readonly firstName: string | null, readonly lastName: string | null, readonly id: string, readonly sortName: string | null };

type DebtorAndFamilyGroupMembers_groupFragment = DebtorAndFamilyGroupMembers_group_Organisation_Fragment | DebtorAndFamilyGroupMembers_group_Person_Fragment;



export type type = TypedDocumentNode<{
  type: "fragment";
  result: DebtorAndFamilyGroupMembers_groupFragment;
  name: "DebtorAndFamilyGroupMembers_group";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    DebtorAndFamilyGroupMembers_group: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"DebtorAndFamilyGroupMembers_group\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Client\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"sortName\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Organisation\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"registeredName\"},\"arguments\":[],\"directives\":[]}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Person\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"firstName\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"lastName\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
